import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import FadeIn from "react-fade-in";
import axios from "axios";
import { LOGIN_USER } from "../../../Routes.js";
import { generateURLOptions } from "../../../URLOptions.js";

import { IoEyeOutline, IoEye } from "react-icons/io5";

import MP_LOGO from "../../../assets/images/login_logo.png";
import CommonTextField from "../../../InterstellrComponents/CommonTextField.jsx";
import FilledButton from "../../../InterstellrComponents/FilledButton.jsx";
import { UserContext } from "../../../storage/contexts/UserContext.js";

const Login = () => {
  const { setProfile } = useContext(UserContext);

  const [visible, setVisible] = useState(true);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Mind Pulse | Powered by Adaptive Psychology";
  }, []);

  const loginUser = async () => {
    try {
      const response = await axios.post(
        LOGIN_USER,
        {
          email: username,
          password: password,
        },
        {
          headers: generateURLOptions(),
        }
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      console.log("Response: ", response.data);

      localStorage.setItem("accessToken", response?.data?.data?.token);
      localStorage.setItem("userType", response?.data?.data?.user?.usertype);
      setProfile(response?.data?.data?.user);
      setVisible(false);

      // Redirect to Superadmin if the usertype is 3 || 4
      if (
        response?.data?.data?.user?.usertype == 3 ||
        response?.data?.data?.user?.usertype == 4
      ) {
        setTimeout(() => {
          return navigate("/organisation/pulse");
        }, 350);
        return;
      }

      setTimeout(() => {
        return navigate("/dashboard");
      }, 350);
    } catch (error) {
      console.error("Login Error: ", error);
      return alert(error);
    }
  };

  return (
    <>
      <FadeIn className="overflow-hidden" visible={visible}>
        <div className="flex flex-row">
          <div className="w-full md:w-1/2">
            <div className="flex h-screen flex-col justify-center items-center">
              <div className="w-full md:w-2/3 px-6 md:px-0">
                <img
                  className="flex md:hidden w-full h-40 object-contain"
                  src={MP_LOGO}
                />

                <h5 className="font-medium text-black text-xl mb-4 mt-4">
                  Login to Mind Pulse
                </h5>

                <CommonTextField
                  title={"Email Address"}
                  placeholder={"Email Address"}
                  type="email"
                  value={username}
                  onChange={setUsername}
                />

                <CommonTextField
                  title={"Password"}
                  placeholder={"Password"}
                  type="password"
                  value={password}
                  onChange={setPassword}
                  showPassword={showPassword}
                  suffixIcon={
                    showPassword ? (
                      <IoEye
                        onClick={() => setShowPassword(false)}
                        color="#5153F5"
                        className="text-2xl mr-4"
                      />
                    ) : (
                      <IoEyeOutline
                        onClick={() => setShowPassword(true)}
                        color="#5153F5"
                        className="text-2xl mr-4"
                      />
                    )
                  }
                />

                <div className="flex flex-row items-center mt-2 mb-4">
                  <div className="flex flex-row items-center">
                    <input
                      className="w-4 h-4 bg-white border border-slate-300 rounded-xl"
                      type="checkbox"
                      value={rememberMe}
                      onChange={(e) => setRememberMe(e.target.value)}
                    />
                    <p className="text-black font-normal text-base pb-0 mb-0 ml-2">
                      Remember me
                    </p>
                  </div>

                  <div className="flex-1" />

                  <p
                    onClick={() => navigate("/account-recovery")}
                    className="text-[#5153F5] font-medium text-base cursor-pointer"
                  >
                    Forgot Password ?
                  </p>
                </div>

                <FilledButton text={"Login"} onPress={loginUser} />

                <div className="flex flex-col mt-4 justify-center items-center">
                  <p className="text-base text-black mb-1">
                    Don't have an account yet?
                  </p>
                  <a
                    href="https://onelink.to/3m5z6a"
                    className="text-[#5153F5] font-semibold text-base"
                  >
                    Download the Mind Pulse App to Register
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="relative w-1/2 hidden md:flex flex-col justify-center h-screen">
            <img className="w-full h-1/2 object-contain" src={MP_LOGO} />

            <div className="absolute bottom-10 left-8 right-8 z-10">
              <h2 style={{ color: "#ffffff", fontSize: 28, fontWeight: "600" }}>
                Be Proactive with Health and Wellbeing
              </h2>
              <p style={{ color: "#ffffff", fontSize: 18, fontWeight: "500" }}>
                Login to control the Mind Pulse Platform
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </>
  );
};

export default Login;
